module.exports = "https://static.im-cdn.com/mjc/storefront/Simplar/static/media/Search.d19e80c7.svg";